<template>
  <div>
    <accordion ref="accordionFiltroLote">
      <template #header="{ expandido }">
        <div
          class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center"
        >
          <h4 class="font-size-16 mb-0" style="font-weight: 600">
            FILTRO DE LOTES
          </h4>
        </div>

        <div
          class="col-md-6 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end align-items-center order-1 order-md-2 mb-2 mb-md-0"
        >
          <b-button
            @click.stop="importarCSV"
            variant="warning"
            class="me-md-3 mb-2 mb-md-0"
            ><i class="fa fa-solid fa-upload"></i> Importar CSV
          </b-button>
          <i
            :class="expandido ? 'mdi mdi-filter' : 'mdi mdi-filter-outline'"
            class="icone-accordion"
          ></i>
        </div>
      </template>

      <div class="row d-flex mb-1">
        <!-- Cooperado -->
        <div class="col-md-3">
          <inputCooperado
            :submit="submit"
            :reset="resetCooperado"
            :value="cooperadoSelecionado"
            @cooperadoSelecionado="setCooperado"
          />
        </div>

        <!-- Lote -->
        <div class="col-md-3">
          <b-form-group label="Lote">
            <multiselect
              label="name"
              track-by="name"
              :max-height="150"
              v-model="selecaoLoteVM"
              :loading="loadingLotes"
              :options="selecaoLoteLkp"
              selected-label="Selecionado"
              placeholder="Selecione um lote"
              deselect-label="Pressione Enter para remover"
              select-label="Pressione Enter para selecionar"
            >
              <span slot="noOptions">Nenhum lote disponível</span>
              <span slot="noResult">Nenhum lote encontrado</span>
            </multiselect>
          </b-form-group>
        </div>

        <!-- Data de Importação -->
        <div class="col-md-3">
          <b-form-group
            label="Data do Importação"
            invalid-feedback="Campo obrigatório"
          >
            <date-picker
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              v-model="dataImportacaoVM"
              value-type="YYYY-MM-DD HH:mm:ss"
            />
          </b-form-group>
        </div>

        <!-- Status -->
        <div class="col-md-3">
          <b-form-group label="Status">
            <multiselect
              label="name"
              track-by="name"
              :max-height="200"
              v-model="selecaoStatusVM"
              :options="selecaoStatusLkp"
              selected-label="Selecionado"
              placeholder="Selecione um status"
              deselect-label="Pressione Enter para remover"
              select-label="Pressione Enter para selecionar"
            >
              <span slot="noOptions">Nenhum status disponível</span>
              <span slot="noResult">Nenhum status encontrado</span>
            </multiselect>
          </b-form-group>
        </div>
      </div>

      <!-- Botões Limpar / Filtrar -->
      <div class="row py-2">
        <div
          class="col-md-6 col-sm-12 d-flex flex-column flex-md-row gap-2 mb-2 mb-md-0 order-2 order-md-1"
        >
          <b-button
            variant="secondary"
            class="mb-2 mb-md-0"
            @click="limparFiltrosLotes"
          >
            <i class="mdi mdi-broom"></i> Limpar
          </b-button>
          <b-button
            variant="primary"
            @click="emitirFiltro"
            :disabled="disabledFiltro"
          >
            <i class="mdi mdi-filter-outline"></i> Filtrar
            <b-spinner
              variant="secondary"
              small
              v-if="disabledFiltro"
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </accordion>

    <modalImportacao ref="modalImportacao" @errosImportacao="abrirModalErros" />

    <modalErrosImportacao ref="modalErrosImportacao" :erros="errosImportacao" />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import accordion from "@/components/accordion";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { filtrosLotesHelper } from "@/store/helpers/vuex/astec";
import inputCooperado from "@/components/astec/projetos/lotesImportacao/inputCooperado";
import modalImportacao from "@/components/astec/projetos/lotesImportacao/modalImportacao";
import modalErrosImportacao from "@/components/astec/projetos/lotesImportacao/modalErrosImportacao";

export default {
  mixins: [clienteRuralMixin],
  components: {
    Multiselect,
    accordion,
    inputCooperado,
    modalImportacao,
    modalErrosImportacao
  },

  props: {
    atualizarLkpLote: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      submit: false,
      loadingLotes: false,
      disabledFiltro: false,
      filtroCarregou: false,
      selecaoLoteLkp: [],
      selecaoStatusLkp: [
        { name: "Pendente", value: "PENDENTE" },
        { name: "Parcial", value: "PARCIAL" },
        { name: "Concluído", value: "CONCLUÍDO" }
      ],
      resetCooperado: 0,
      errosImportacao: [],
      inicializado: false,
      LimparAoSair: false
    };
  },

  computed: {
    ...filtrosLotesHelper().computed,

    cooperadoSelecionado() {
      if (!this.cdPessoa || !this.cdPessoaNome) {
        return null;
      }
      return {
        value: this.cdPessoa,
        name: this.cdPessoaNome
      };
    },

    selecaoLoteVM: {
      get() {
        if (
          this.selecaoLote &&
          this.selecaoLote.value &&
          this.selecaoLoteLkp.length > 0
        ) {
          const encontrado = this.selecaoLoteLkp.find(
            lote => lote.value === this.selecaoLote.value
          );

          if (encontrado) {
            console.log("Lote encontrado na lista:", encontrado);
            return encontrado;
          } else {
            console.warn(
              "Lote não encontrado na lista, mantendo do Vuex:",
              this.selecaoLote
            );
            return this.selecaoLote;
          }
        }
        return this.selecaoLote;
      },
      set(val) {
        console.log("Setando lote no Vuex:", val);
        this.setFiltro({
          ...this.filtroCompleto,
          selecaoLote: val
        });
      }
    },

    selecaoStatusVM: {
      get() {
        if (this.selecaoStatus && this.selecaoStatus.value) {
          const encontrado = this.selecaoStatusLkp.find(
            status => status.value === this.selecaoStatus.value
          );
          return encontrado || this.selecaoStatus;
        }
        return this.selecaoStatus;
      },
      set(val) {
        this.setFiltro({
          ...this.filtroCompleto,
          selecaoStatus: val
        });
      }
    },

    dataImportacaoVM: {
      get() {
        return this.dataImportacao;
      },
      set(val) {
        this.setFiltro({
          ...this.filtroCompleto,
          dataImportacao: val
        });
      }
    }
  },

  watch: {
    atualizarLkpLote(newValue) {
      if (newValue && this.cdPessoa) {
        this.buscarLkpLote(this.cdPessoa);
      }
    },

    cdPessoa: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal || !this.inicializado) {
          if (newVal) {
            this.buscarLkpLote(newVal);
          } else {
            this.selecaoLoteLkp = [];
          }
        }
      },
      immediate: true
    },

    selecaoLoteLkp: {
      handler(novaLista) {
        if (
          novaLista.length > 0 &&
          this.selecaoLote &&
          this.selecaoLote.value
        ) {
          this.$nextTick(() => {
            this.sincronizarLoteComLista();
          });
        }
      },
      deep: true
    }
  },

  mounted() {
    if (this.cdPessoa) {
      this.buscarLkpLote(this.cdPessoa);
    }

    if (this.selecaoStatus && this.selecaoStatus.value) {
      this.$nextTick(() => {
        const statusExato = this.selecaoStatusLkp.find(
          status => status.value === this.selecaoStatus.value
        );
        if (statusExato && statusExato !== this.selecaoStatus) {
          this.setFiltro({
            ...this.filtroCompleto,
            selecaoStatus: statusExato
          });
        }
      });
    }

    this.inicializado = true;
    if (this.cdPessoa) this.emitirFiltro();
  },

  methods: {
    ...filtrosLotesHelper().methods,

    async buscarLkpLote(cdPessoa) {
      if (!cdPessoa) {
        this.selecaoLoteLkp = [];
        if (this.selecaoLote) {
          this.setFiltro({
            ...this.filtroCompleto,
            selecaoLote: null
          });
        }
        return;
      }

      this.loadingLotes = true;

      try {
        const response = await this.$http.get(
          `/api/astec/projetos/importarProjetos/getLkpLote/${cdPessoa}`
        );

        this.selecaoLoteLkp = response?.data?.lotes || [];
        this.$nextTick(() => {
          if (this.selecaoLote && this.selecaoLote.value) {
            this.$forceUpdate();
            const loteExiste = this.selecaoLoteLkp.some(
              lote => lote.value === this.selecaoLote.value
            );
            if (!loteExiste) {
              this.setFiltro({
                ...this.filtroCompleto,
                selecaoLote: null
              });
            }
          }
        });
      } catch (error) {
        console.error("Erro ao buscar lotes:", error);
        this.selecaoLoteLkp = [];
      } finally {
        this.loadingLotes = false;
      }
    },

    limparFiltrosLotes() {
      this.submit = false;
      this.limparFiltros();
      this.selecaoLoteLkp = [];
      this.resetCooperado++;
      this.$emit("limparGrid");
      console.log("Filtros limpos");
    },

    emitirFiltro() {
      this.submit = true;

      if (!this.cdPessoa) {
        this.$tools.alerta("Selecione um cooperado para filtrar", "warning");
        return;
      }

      const filtroApi = {
        sq_astec_integracao_lote: this.selecaoLote?.value ?? null,
        dt_importacao: this.dataImportacao ?? null,
        status: this.selecaoStatus?.value ?? null,
        cd_pessoa: this.cdPessoa ?? null
      };
      this.$emit("filtroLote", filtroApi);

      if (!this.filtroCarregou) {
        this.filtroCarregou = true;
      } else {
        this.$refs.accordionFiltroLote?.fechar();
      }
    },

    setCooperado(cooperado) {
      if (!cooperado) {
        this.setFiltro({
          cdPessoa: null,
          cdPessoaNome: null,
          selecaoLote: null
        });

        this.selecaoLoteLkp = [];
        return;
      }

      this.setFiltro({
        cdPessoa: cooperado?.value ?? null,
        cdPessoaNome: cooperado?.name ?? null
      });

      if (cooperado?.value) {
        this.buscarLkpLote(cooperado.value);
      }
    },

    importarCSV() {
      if (!this.cdPessoa || !this.cdPessoaNome) {
        this.$refs.modalImportacao.abrirModal(cooperadoParaEnviar);
      }
      let cooperadoParaEnviar = null;

      try {
        if (this.cooperadoSelecionado && this.cooperadoSelecionado.value) {
          cooperadoParaEnviar = {
            name: this.cooperadoSelecionado.name || this.cdPessoaNome,
            value: this.cooperadoSelecionado.value
          };
        } else {
          cooperadoParaEnviar = {
            name: this.cdPessoaNome,
            value: this.cdPessoa
          };
        }
        this.$refs.modalImportacao.abrirModal(cooperadoParaEnviar);
      } catch (error) {
        this.$tools.alerta(
          "Erro ao preparar importação. Tente novamente.",
          "error"
        );
      }
    },

    abrirModalErros(erros) {
      this.errosImportacao = erros;
      this.$refs.modalErrosImportacao.abrirModalErrosImport();
    },

    sincronizarLoteComLista() {
      if (
        this.selecaoLote &&
        this.selecaoLote.value &&
        this.selecaoLoteLkp.length > 0
      ) {
        const loteExato = this.selecaoLoteLkp.find(
          lote => lote.value === this.selecaoLote.value
        );

        if (loteExato && loteExato !== this.selecaoLote) {
          console.log("Sincronizando lote com objeto da lista");
          this.setFiltro({
            ...this.filtroCompleto,
            selecaoLote: loteExato
          });
        }
      }
    }
  }
};
</script>
